import { Directive, HostBinding, HostListener } from '@angular/core';
import { CONTROL_KEYS } from '../../core/constants/constants';

@Directive({
  selector: '[onlyAlphabets]',
})
export class OnlyAlphabetsDirective {
  @HostBinding('autocomplete') public autocomplete;

  constructor() {
    this.autocomplete = 'off';
  }

  @HostListener('keydown', ['$event'])
  public disableKeys(event: KeyboardEvent): boolean {
    if (CONTROL_KEYS.includes(event.key)) {
      return true;
    }

    return /^[A-Za-zÀ-ÿ\s]$/.test(event.key);
  }
}
